import { render, staticRenderFns } from "./user-search-result.vue?vue&type=template&id=8961de3c&scoped=true&"
import script from "./user-search-result.vue?vue&type=script&lang=js&"
export * from "./user-search-result.vue?vue&type=script&lang=js&"
import style0 from "./user-search-result.vue?vue&type=style&index=0&id=8961de3c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8961de3c",
  null
  
)

export default component.exports